module.exports = __webpack_public_path__ + "static/media/logo-nautile.8f45dc6f.svg";